// extracted by mini-css-extract-plugin
export default {"history-item":"UserHistoryAction_history-item__CJWEw","history-item__value":"UserHistoryAction_history-item__value__On+Su"};